<!-- eslint-disable max-len -->
<template>
  <div>
    <div @click="toggleBackground" class="virtual-tour__show-btn">
      <svg xmlns="http://www.w3.org/2000/svg" height="50px" width="40px" viewBox="0 -960 960 960"  fill="#FFFFFF">
      <path v-if="!visibility" d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/>
      <path v-if="visibility" d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"/>
    </svg>
    </div>
    <div class="virtual-tour__section backdrop backdrop--light">
      <!-- eslint-disable max-len -->
      <div class="custom-bg js-custom-tour-bg" v-if="bg">
        <img :src="`${cmsURL}assets/${bg}`" />
      </div>

      <div class="virtual-tour__title text-center">
        <h2 class="title js-title">
          {{ data.headline }}
        </h2>
        <h5 class="title title--small js-subtitle" v-if="data.description">
          {{ data.description }}
        </h5>
      </div>

      <div class="inner-content" v-if="data.inner_points">
        <div class="container-fluid px-5">
          <div class="virtual-tour__points-holder">
            <div
              v-for="(item, index) in data.inner_points"
              :data-slide-to="index"
              href="#virtual-tour__carousel"
              :key="index">
              <Hotspot
                :class="[`hotspot--${index + 1}`,'js-hotspot']"
                data-target="#modal-tour-slider"
                data-toggle="modal"
                :gtmLabel="`Click Option ${item.point_letter}`"
                parent="Virtual Tour"
                :position="item.label_position"
                subSection="Press Station"
                :style="{
                  top: item.position_top,
                  left: item.position_left
                }"
                :title="item.point_label"
                @click="clickTracked($event)">
                {{ item.point_letter }}
              </Hotspot>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Carousel Bootstrap -->
    <Modal idModal="modal-tour-slider" >
      <div
        class="carousel slide js-carousel"
        id="virtual-tour__carousel"
        data-interval="false"
        data-ride="carousel"
        data-wrap="false" >
        <div class="carousel-inner">
          <div
            v-for="(item, index) in data.inner_points"
            :class="['carousel-item',
            {'carousel-item--note': item.note},
            {'active': index === 0}]"
            :key="index">
            <template v-if="item.media_items">
              <template v-if="item.media_items.length < 2">
                <Media
                  v-for="(media, index) in item.media_items"
                  class="js-media-wrapper"
                  :key="index"
                  :poster="media.poster"
                  :src="media.source"
                  :title="item.media_caption"
                  :type="media.type">
                  <template v-slot:content>
                    <div class="content" v-html="item.media_content"></div>
                  </template>
                  <template v-slot:note>
                    <small v-if="item.note">
                      {{ item.note }}
                    </small>
                  </template>
                </Media>
              </template>
              <template v-else>
                <div class="media-gallery">
                  <Media
                    v-for="(media, index) in item.media_items"
                    :class="['js-media-wrapper', `js-media-wrapper--${index}`,
                    {'active': index === 0}]"
                    :key="index"
                    :poster="media.poster"
                    :src="media.source"
                    :title="item.media_caption"
                    :type="media.type">
                    <template v-slot:content>
                      <div class="content" v-html="item.media_content"></div>
                    </template>
                    <template v-slot:note>
                      <small v-if="item.note">
                        {{ item.note }}
                      </small>
                    </template>
                  </Media>

                  <div class="media-gallery__thumbs">
                    <a
                      v-for="(media, index) in item.media_items"
                      :class="['single-thumb', 'js-media-nav',
                      {'active': index === 0}]"
                      href="javascript:void(0)"
                      :key="index"
                      @click="changeImg(`${index}`, $event.target)">
                      <img
                        :alt="item.media_caption"
                        class="img-fluid object-fit-cover-center"
                        :src="(media.type === 'video') ? media.poster : media.source" />
                    </a>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="text-only">
                <h4 class="title">
                  {{ item.media_caption }}
                </h4>

                <div v-html="item.media_content"></div>

                <small v-if="item.note">
                  {{ item.note }}
                </small>
              </div>
            </template>
          </div>
        </div>

        <template v-if="data.inner_points">
          <a
            v-if="data.inner_points.length > 1"
            class="carousel-control-prev js-prev"
            data-slide="prev"
            href="#virtual-tour__carousel"
            role="button">
            <span class="icon">
              <svg width="17px" height="17px" viewBox="0 0 17 17" >
                <polygon class="st0" points="8.6,16.7 0.3,8.4 8.6,0 10.1,1.5 4.3,7.3 17,7.3 17,9.4 4.3,9.4 10.1,15.2 "/>
              </svg>
            </span>
            <span class="page-name"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a
            v-if="data.inner_points.length > 1"
            class="carousel-control-next js-next active"
            data-slide="next"
            href="#virtual-tour__carousel"
            role="button">
            <span class="icon">
              <svg width="17px" height="17px" viewBox="0 0 17 17">
                <polygon class="st0" points="8.6,0 17,8.4 8.6,16.7 7.2,15.2 13,9.4 0.3,9.4 0.3,7.3 13,7.3 7.2,1.5 "/>
              </svg>
            </span>
            <span class="page-name"></span>
            <span class="sr-only">Next</span>
          </a>
        </template>
      </div>
    </Modal>
  </div>
</template>

<script>
import $ from 'jquery';
import { gsap } from 'gsap';

import * as endpoints from '@/common/endpoints';
import { defaultMixins } from '@/common/mixins';
import { showElement } from '@/common/animations';

import Hotspot from '@/components/ui/VirtualTourPoint.vue';
import Media from '@/components/ui/Media.vue';
import Modal from '@/components/modal/Modal.vue';

export default {
  name: 'TourInnerPoints',
  mixins: [defaultMixins],
  components: {
    Hotspot,
    Media,
    Modal,
  },
  props: {
    bg: String,
    data: Object,
  },
  data() {
    return {
      cmsURL: endpoints.CMS,
      visibility: true,
    };
  },
  mounted() {
    const mainTl = gsap.timeline();

    if ($('.js-custom-tour-bg').length > 0) {
      mainTl.to('.js-custom-tour-bg', {
        opacity: 1,
        duration: 0.3,
      });
    }

    mainTl.add(showElement('.js-title', 'top'))
      .add(showElement('.js-subtitle', 'top'))
      .add(showElement('.js-hotspot', 'top'));

    // Open Modal Event Listener
    $('#modal-tour-slider').on('show.bs.modal', () => {
      if ($('.js-carousel').find('.carousel-item.active').index() === 0) {
        $('.js-prev').removeClass('active');
      } else {
        $('.js-prev').addClass('active');
      }
    });

    // Modal Carousel event listener
    $('.js-carousel').on('slide.bs.carousel', (e) => {
      const thisCarousel = $('.js-carousel');
      const slidingItemsAsIndex = thisCarousel.find('.carousel-item').length - 1;
      const video = document.getElementsByTagName('video');

      // Pause Videos
      if (video.length > 0) {
        for (let index = 0; index < video.length; index += 1) {
          video[index].pause();
        }
      }

      // If first item hide prev arrow
      if ($(e.relatedTarget).index() === 0) {
        $('.js-prev').removeClass('active');
      } else {
        $('.js-prev').addClass('active');
      }

      // If last item hide next arrow
      if ($(e.relatedTarget).index() === slidingItemsAsIndex) {
        $('.js-next').removeClass('active');
      } else {
        $('.js-next').addClass('active');
      }
    });
  },
  beforeUnmount() {
    if ($('.js-custom-tour-bg').length > 0) {
      gsap.timeline()
        .to('.js-custom-tour-bg', {
          opacity: 0,
          duration: 0.5,
        });
    }
  },
  methods: {
    // Change item if is gallery
    changeImg(target, _this) {
      const video = document.getElementsByTagName('video');

      if (video.length > 0) {
        for (let index = 0; index < video.length; index += 1) {
          video[index].pause();
        }
      }

      $('.js-media-nav').removeClass('active');
      $(_this).parent().addClass('active');

      $('.js-media-wrapper').hide().removeClass('active');
      $(`.js-media-wrapper--${target}`).fadeIn().addClass('active');
    },
    toggleBackground() {
      const bgElement = document.querySelector('.virtual-tour__section');
      if (bgElement) {
        if (this.visibility === false) {
          bgElement.style.display = 'block';
          gsap.to('.virtual-tour__section', {
            opacity: 1,
            duration: 0.3,
          });
          this.visibility = true;
        } else {
          gsap.to('.virtual-tour__section', {
            opacity: 0,
            duration: 0.3,
            onComplete: () => {
              bgElement.style.display = 'none';
            },
          });
          this.visibility = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/views/virtual-tour/sections.scss';
</style>
